import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'kt-app-loader',
  templateUrl: './app-loader.component.html',
  styleUrls: ['./app-loader.component.scss']
})
export class AppLoaderComponent implements OnInit {
  @Input()loader:boolean=false;
  constructor() { }

  ngOnInit() {
  }

}
